import ErrorFallback from 'Components/ErrorFallback'
import AuthoritySelectionRequired from 'Services/common/Features/Authority/Components/AuthoritySelectionRequired'
import {
  ServiceProviderCreatePage,
  ServiceProviderEditPage,
  ServiceProviderListPage
} from 'Services/ServiceProviderManagement/Features/ServiceProvider/Pages'
import { ErrorBoundary } from 'react-error-boundary'
import { Route, Routes } from 'react-router-dom'

function ServiceProviderRoot() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Routes>
        <Route index element={<ServiceProviderListPage />} />
        <Route element={<AuthoritySelectionRequired backButtonFallbackPath="./" />}>
          <Route path="create" element={<ServiceProviderCreatePage />} />
          <Route path=":id/edit" element={<ServiceProviderEditPage />} />
        </Route>
      </Routes>
    </ErrorBoundary>
  )
}

export default ServiceProviderRoot
